import { useNavigate } from "react-router-dom";
import { XCircle } from "lucide-react";
import { Button } from "@/components/ui/button";

export default function PaymentCancel() {
  const navigate = useNavigate();
  return (
    <div className="grid min-h-screen place-items-center bg-background p-6" data-testid="payment-cancel-page">
      <div className="w-full max-w-md rounded-2xl border border-border bg-card p-8 text-center">
        <XCircle className="mx-auto h-12 w-12 text-muted-foreground" />
        <h1 className="mt-4 font-display text-2xl font-bold">Paiement annulé</h1>
        <p className="mt-2 text-sm text-muted-foreground">Aucun montant n'a été débité. Vous pouvez réessayer quand vous le souhaitez.</p>
        <div className="mt-6 flex justify-center gap-3">
          <Button onClick={() => navigate("/#tarifs")} className="rounded-full bg-gold-500 text-black hover:bg-gold-400">Revoir les tarifs</Button>
          <Button onClick={() => navigate("/")} variant="outline" className="rounded-full">Accueil</Button>
        </div>
      </div>
    </div>
  );
}
